import React from "react";
import { Message } from "lib/components/index";

import st from "lib/utils/index";
import * as FormControl from "lib/components/FormControl";
import { ProductPricelistItemDecorator } from "lib/decorators/index";
import { Fragment } from "react";
import { relativeTimeRounding } from "../../../../../node_modules/moment/moment";

export default class ProductPricelistItemFormSection extends React.PureComponent {
  componentDidMount() {
    //console.log(this.props)

    if (
      this.props.pricelist_type === "pricelist_by_person" &&
      !this.props.readOnlyAccess &&
      this.props.isFirstItem &&
      this.props.product_pricelist_item._new
    ) {
      if (this.props.product.product_type === "standard") {
        this.handlePropChange("preset_id", "preset_person_everyone");
        return;
      }
      if (this.props.product.product_type === "ticket") {
        this.handlePropChange("preset_id", "preset_person_adult");
        return;
      }
    }
  }
  handlePropChange(prop, value) {
    console.log(prop);
    console.log(value);

    const { product_pricelist_item, pricelist_type, onChange } = this.props;
    const anyPreset = ProductPricelistItemDecorator.presets.find((pr) => pr.pricelist_type === pricelist_type);
    const nextProductPricelistItem = new ProductPricelistItemDecorator({
      ...product_pricelist_item,
      preset_id: product_pricelist_item.preset_id || (anyPreset && anyPreset.preset_id),
      [prop]: value,
    });
    console.log(nextProductPricelistItem);
    onChange(nextProductPricelistItem);
  }

  handleTranslationPropChange(prop, value) {
    const { product_pricelist_item, editedLocale, pricelist_type, onChange } = this.props;
    const anyPreset = ProductPricelistItemDecorator.presets.find((pr) => pr.pricelist_type === pricelist_type);
    const nextProductPricelistItem = new ProductPricelistItemDecorator({
      ...product_pricelist_item,
      preset_id: product_pricelist_item.preset_id || (anyPreset && anyPreset.preset_id),
      translations: product_pricelist_item.translations
        .filter((t) => t.locale !== editedLocale)
        .concat([{ ...product_pricelist_item.getTranslation(editedLocale), [prop]: value }]),
    });
    onChange(nextProductPricelistItem);
  }

  renderAdditionalFields() {
    const { readOnlyAccess, pricelist_type, product_pricelist_item, errors, name, onBlur, onRemove, isFirstItem } =
      this.props;
    return (
      <div className="fields inline">
        {!product_pricelist_item._new && product_pricelist_item.isAttributeEditable("persons_count") && (
          <FormControl.InputFormGroup
            {...FormControl.addProps(`${name}.persons_count`, { errors })}
            value={product_pricelist_item.persons_count}
            onBlur={onBlur}
            onChange={this.handlePropChange.bind(this, "persons_count")}
            type="number"
            min="0"
            className="u-tinyWidth"
            autoFocus={this._getAutoFocusOnce()}
            label={I18n.t("papp.products.EditProductView.StepPricelist.persons_count")}
            readOnly={readOnlyAccess}
          />
        )}

        {!product_pricelist_item._new && product_pricelist_item.isAttributeEditable("min_persons_count") && (
          <FormControl.InputFormGroup
            {...FormControl.addProps(`${name}.min_persons_count`, { errors })}
            value={product_pricelist_item.min_persons_count}
            onBlur={onBlur}
            onChange={this.handlePropChange.bind(this, "min_persons_count")}
            type="number"
            min="0"
            className="u-tinyWidth"
            autoFocus={this._getAutoFocusOnce()}
            label={I18n.t("papp.products.EditProductView.StepPricelist.persons_count_from")}
            readOnly={readOnlyAccess}
          />
        )}

        {!product_pricelist_item._new && product_pricelist_item.isAttributeEditable("max_persons_count") && (
          <FormControl.InputFormGroup
            {...FormControl.addProps(`${name}.max_persons_count`, { errors })}
            value={product_pricelist_item.max_persons_count}
            onBlur={onBlur}
            onChange={this.handlePropChange.bind(this, "max_persons_count")}
            type="number"
            min="0"
            className="u-tinyWidth"
            autoFocus={this._getAutoFocusOnce()}
            label={I18n.t("base.to")}
            readOnly={readOnlyAccess}
          />
        )}

        {!product_pricelist_item._new && product_pricelist_item.isAttributeEditable("min_person_age") && (
          <FormControl.InputFormGroup
            {...FormControl.addProps(`${name}.min_person_age`, { errors })}
            value={product_pricelist_item.min_person_age}
            onBlur={onBlur}
            onChange={this.handlePropChange.bind(this, "min_person_age")}
            type="number"
            min="0"
            max="100"
            className="u-tinyWidth"
            autoFocus={this._getAutoFocusOnce()}
            label={I18n.t("papp.products.EditProductView.StepPricelist.age_from")}
            readOnly={readOnlyAccess}
          />
        )}

        {!product_pricelist_item._new && product_pricelist_item.isAttributeEditable("max_person_age") && (
          <FormControl.InputFormGroup
            {...FormControl.addProps(`${name}.max_person_age`, { errors })}
            value={product_pricelist_item.max_person_age}
            onBlur={onBlur}
            onChange={this.handlePropChange.bind(this, "max_person_age")}
            type="number"
            min="0"
            max="100"
            className="u-tinyWidth"
            autoFocus={this._getAutoFocusOnce()}
            label={I18n.t("base.to")}
            readOnly={readOnlyAccess}
          />
        )}

      </div>
    );
  }

  _getAutoFocusOnce() {
    if (!this._autofocused && this.props.product_pricelist_item._focus) {
      this._autofocused = true;
      return true;
    } else {
      return undefined;
    }
  }

  render() {
    const {
      readOnlyAccess,
      pricelist_type,
      editedLocale,
      product_pricelist_item,
      errors,
      name,
      onBlur,
      onRemove,
      isFirstItem,
    } = this.props;

    let product_price_currency = this.props.product_price_currency || "PLN";

    const presetsOptions = ProductPricelistItemDecorator.presets
      .filter((pr) => pr.pricelist_type === pricelist_type)
      .map((pr) => [pr.preset_id, I18n.humanAttributeName("product_pricelist_item", pr.preset_id)]);
    this._autofocused = false;
    const useMultiRowLayout = product_pricelist_item.preset_id === "preset_person_custom";
    product_pricelist_item.price_before_discount = product_pricelist_item.price_before_discount || 0;

    const itemStyle = {
      border: "1px solid #e8e8e8",
      borderRadius: "4px",
      padding: "1em",
      marginBottom: "1em",
    };

    return (
      <div style={!product_pricelist_item._new ? itemStyle : undefined}>
        <div className={"fields inline u-positionRelative u-paddingRight " + pricelist_type}>
          {!!errors[name] && <FormMessage error={errors[name]} />}

          {pricelist_type === "pricelist_by_person" && (
            <FormControl.SelectFormGroup
              {...FormControl.addProps(`${name}.preset_id`, { errors })}
              value={product_pricelist_item.preset_id}
              onBlur={onBlur}
              onChange={this.handlePropChange.bind(this, "preset_id")}
              placeholder={I18n.humanAttributeName("product_pricelist_item", "preset_id")}
              required={!product_pricelist_item._new}
              options={presetsOptions}
              className="u-mediumWidth"
              readOnly={readOnlyAccess}
            />
          )}

          {(!product_pricelist_item._new || pricelist_type !== "pricelist_by_person") &&
            product_pricelist_item.isAttributeEditable("name") && (
              <FormControl.InputFormGroup
                {...FormControl.addProps(`${name}.name`, { errors })}
                value={product_pricelist_item.getTranslation(editedLocale).name}
                onBlur={onBlur}
                onChange={this.handleTranslationPropChange.bind(this, "name")}
                placeholder={
                  pricelist_type === "pricelist_by_person"
                    ? I18n.t("papp.products.EditProductView.StepPricelist.person_category_name")
                    : product_pricelist_item._new
                    ? I18n.t("papp.products.EditProductView.StepPricelist.add_new_item")
                    : I18n.t("papp.products.EditProductView.StepPricelist.item_name")
                }
                required={!product_pricelist_item._new}
                autoFocus={this._getAutoFocusOnce()}
                readOnly={readOnlyAccess}
              />
            )}

          {!useMultiRowLayout && this.renderAdditionalFields()}

          <div style={{ flexGrow: 1 }} />

          {!product_pricelist_item._new && product_pricelist_item.isAttributeEditable("price_type") && (
            <FormControl.SelectFormGroup
              {...FormControl.addProps(`${name}.price_type`, { errors })}
              value={product_pricelist_item.price_type}
              onBlur={onBlur}
              onChange={this.handlePropChange.bind(this, "price_type")}
              placeholder={I18n.humanAttributeName("product_pricelist_item", "price_type")}
              required={!product_pricelist_item._new}
              options={ProductPricelistItemDecorator.price_type_options}
              className="u-mediumWidth"
              autoFocus={this._getAutoFocusOnce()}
              readOnly={readOnlyAccess}
            />
          )}

          {!product_pricelist_item._new && (
            <FormControl.FormGroup error={errors[`${name}.price`]}>
              <FormControl.Money
                value={product_pricelist_item.price}
                onBlur={onBlur}
                onChange={this.handlePropChange.bind(this, "price")}
                placeholder={I18n.humanAttributeName("product_pricelist_item", "price")}
                required={!product_pricelist_item._new}
                currencyEditable={true}
                autoFocus={this._getAutoFocusOnce()}
                min={0}
                defaultCurrency={product_price_currency}
                readOnly={readOnlyAccess}
              />
            </FormControl.FormGroup>
          )}

          {!readOnlyAccess &&
            !product_pricelist_item._new &&
            product_pricelist_item.pricelist_type !== "pricelist_by_order" && (
              <FormControl.DeleteRowButton onClick={onRemove} />
            )}
        </div>

        {!product_pricelist_item._new && product_pricelist_item.pricelist_type === "pricelist_by_person" && product_pricelist_item.isAttributeEditable("min_quantity") && (
          <div className="fields inline u-paddingRight" style={{ paddingLeft: "11em" }}>
            <FormControl.InputFormGroup
              {...FormControl.addProps(`${name}._min_quantity`, { errors })}
              value={product_pricelist_item._min_quantity}
              onBlur={onBlur}
              onChange={this.handlePropChange.bind(this, "_min_quantity")}
              type="number"
              min="1"
              className="u-tinyWidth"
              label={I18n.t("papp.products.EditProductView.StepPricelist.min_quantity")}
              readOnly={readOnlyAccess}
            />
            <FormControl.InputFormGroup
              {...FormControl.addProps(`${name}._max_quantity`, { errors })}
              value={product_pricelist_item._max_quantity}
              onBlur={onBlur}
              onChange={this.handlePropChange.bind(this, "_max_quantity")}
              type="number"
              min="1"
              className="u-tinyWidth"
              label={I18n.t("papp.products.EditProductView.StepPricelist.max_quantity")}
              readOnly={readOnlyAccess}
            />
          </div>
        )}

        {useMultiRowLayout && (
          <div className="fields inline u-paddingRight" style={{ paddingLeft: "11em" }}>
            {this.renderAdditionalFields()}
          </div>
        )}

        {!product_pricelist_item._new && (
          <div className="fields inline u-paddingRight" style={pricelist_type === "pricelist_by_person" ? { paddingLeft: "11em" } : undefined}>
            <FormControl.FormGroup>
              <label>{I18n.humanAttributeName("product_pricelist_item", "price_before_discount")}</label>
              <FormControl.Money
                value={product_pricelist_item.price_before_discount}
                onBlur={onBlur}
                onChange={this.handlePropChange.bind(this, "price_before_discount")}
                placeholder={I18n.humanAttributeName("product_pricelist_item", "price")}
                min={0}
                defaultCurrency={product_price_currency}
                currencyEditable={false}
                readOnly={false}
              />
            </FormControl.FormGroup>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepPricelist/ProductPricelistItemFormSection.jsx